module.exports = __webpack_public_path__ + "static/img/gs.91ad8e83.svg";